import styled from "styled-components"
import { darken } from "polished"

const Link = "#3173dc"

export const Button = styled.button`
  background: ${Link};
  color: white;
  font-size: 1em;
  padding-bottom: calc(0.5em - 1px);
  padding-left: 1em;
  padding-right: 1em;
  padding-top: calc(0.5em - 1px);
  border: 1px solid transparent;
  border-radius: 3px;
  outline: none;
  cursor: pointer;

  &:hover {
    background-color: ${darken(0.025, Link)};
  }

  &:active {
    background-color: ${darken(0.05, Link)};
  }
`
